import { render, staticRenderFns } from "./TemplateMessageEdit.vue?vue&type=template&id=def6d72c"
import script from "./TemplateMessageEdit.vue?vue&type=script&lang=js"
export * from "./TemplateMessageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports